module.exports = __webpack_public_path__ + "static/img/07watch.0ac8294.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/07watch.png
// module id = r1FM
// module chunks = 1